<template>
  <el-dialog
    :title="globalMode ? '微信系统预设属性设置' : '微信类目属性设置'"
    :visible.sync="visible"
    width="92%"
    top="4vh"
    class="custom-el-wrapper"
    custom-class="wechat-category-attribute-dialog"
    :close-on-click-modal="false"
    :before-close="handleBeforeClose"
    @open="open"
  >
    <wechat-category-attribute-editor
      ref="editor"
      :shop-id="shopId"
      :template-id="templateId"
      :global-mode="globalMode"
      :embedded="false"
      height="62vh"
      @dirty-change="dirty = $event"
      @category-change="canSave = $event"
      @saving-change="saving = $event"
      @saved="$emit('saved')"
    />
    <span slot="footer">
      <el-button @click="requestClose">关闭</el-button>
      <el-button type="primary" :disabled="!canSave" :loading="saving" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import WechatCategoryAttributeEditor from './components/WechatCategoryAttributeEditor.vue'

export default {
  name: 'WechatCategoryAttributeDialog',
  components: { WechatCategoryAttributeEditor },
  props: {
    shopId: { type: Number, required: true },
    templateId: { type: [Number, String], required: true },
    globalMode: { type: Boolean, default: false }
  },
  data () {
    return { visible: false, dirty: false, saving: false, canSave: false }
  },
  methods: {
    show () {
      this.visible = true
    },
    open () {
      this.dirty = false
      this.saving = false
      this.canSave = false
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.initialize()
      })
    },
    save () {
      if (!this.$refs.editor) return
      this.saving = true
      this.$refs.editor.save()
    },
    requestClose () {
      this.handleBeforeClose(() => {
        this.visible = false
      })
    },
    handleBeforeClose (done) {
      if (!this.dirty) return done()
      this.$confirm('存在未保存的类目属性，确认关闭？', '提示', { type: 'warning' })
        .then(() => {
          if (this.$refs.editor) this.$refs.editor.discardDirty()
          done()
        })
        .catch(() => {})
    }
  }
}
</script>

<style>
.wechat-category-attribute-dialog { font-size: 13px; }
.wechat-category-attribute-dialog .el-dialog__header { padding: 18px 20px 12px; }
.wechat-category-attribute-dialog .el-dialog__title { font-size: 17px; line-height: 24px; }
.wechat-category-attribute-dialog .el-dialog__body { padding-top: 10px; }
.wechat-category-attribute-dialog .el-input__inner { height: 36px; font-size: 13px; line-height: 36px; }
.wechat-category-attribute-dialog .el-input__icon { line-height: 36px; }
.wechat-category-attribute-dialog .el-checkbox__label,
.wechat-category-attribute-dialog .el-radio__label,
.wechat-category-attribute-dialog .el-button { font-size: 13px; }
.wechat-category-attribute-dialog .el-dialog__footer { border-top: 1px solid #ebeef5; }
</style>
